var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimestamp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 2.5,
    fill: "#FFF2D4",
    stroke: "#FFDC8B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7340_41069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3359 5.24984H11.9193V4.83317C11.9193 4.604 11.7318 4.4165 11.5026 4.4165C11.2734 4.4165 11.0859 4.604 11.0859 4.83317V5.24984H6.91927V4.83317C6.91927 4.604 6.73177 4.4165 6.5026 4.4165C6.27344 4.4165 6.08594 4.604 6.08594 4.83317V5.24984H5.66927C5.21094 5.24984 4.83594 5.62484 4.83594 6.08317V12.7498C4.83594 13.2082 5.21094 13.5832 5.66927 13.5832H12.3359C12.7943 13.5832 13.1693 13.2082 13.1693 12.7498V6.08317C13.1693 5.62484 12.7943 5.24984 12.3359 5.24984ZM11.9193 12.7498H6.08594C5.85677 12.7498 5.66927 12.5623 5.66927 12.3332V7.33317H12.3359V12.3332C12.3359 12.5623 12.1484 12.7498 11.9193 12.7498Z",
    fill: "#E19F04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7340_41069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimestamp);
export default __webpack_public_path__ + "static/media/timestamp.34997c0ca431e88b5e234fe1a8156d68.svg";
export { ForwardRef as ReactComponent };